window.addEventListener("load", function() {
  $(".footer__link").on("mouseenter", event => {
    $(".footer").addClass("footer--move");
  });

  $(".footer__link").on("mouseleave", event => {
    $(".footer").removeClass("footer--move");
  });
});
